import { promiseDelay, delayWithJitter } from '~/assets/js/utils/delay'

/**
 * @callback requestCallback
 * @returns {Promise}
 */

/**
 * function to perform retry on http calls
 *
 * @param {requestCallback} request - request must be a function that returns the promise to be made
 * @param {number} retries
 * @param {number} delay
 * @returns {Promise}
 */
export function retry (request, {
  retries = 3,
  delay = delayWithJitter(),
} = {}) {
  return request().catch(async (err) => {
    await promiseDelay(delay)

    if (retries > 1) {
      return retry(request, {
        retries: retries - 1,
        delay: delay + delayWithJitter(),
      })
    }

    throw new Error(err)
  })
}
